import request from '@/router/axios'

// export const getList = (params) => {
//   return request({
//     url: '/api/blade-stat/statregion/list',
//     method: 'get',
//     params
//   })
// }
//首页-头部-接口
export const topData = params => {
    // console.log('post提交', params)
    return request({
        url: '/api/blade-stat/home/week',
        method: 'get',
        params
    })
}
// 首页-统计数据-呼叫量
export const statisticsDataCnt = params => {
    // console.log('get提交', params)
    return request({
        url: '/api/blade-stat/home/regionMonth/called',
        method: 'get',
        params
    })
}
// 首页-统计数据-完成量
export const statisticsDataDone = params => {
    // console.log('get提交', params)
    return request({
        url: '/api/blade-stat/home/regionMonth/done',
        method: 'get',
        params
    })
}

// //首页-青少年分布-接口
// export const distributionOfYouthData = params => {
//     // console.log('post提交', params)
//     return request({
//         url: '/api/blade-stat/home/regionType',
//         method: 'get',
//         params
//     })
// }
//首页-年龄段分布-接口
export const ageBracketData = params => {
    // console.log('post提交', params)
    return request({
        url: '/api/blade-stat/wel/ageBracketData',
        method: 'post',
        params
    })
}
//首页-青少年分布-接口
export const adolescentKindData = params => {
    // console.log('post提交', params)
    return request({
        url: '/api/blade-stat/home/regionType',
        method: 'get',
        params
    })
}
//首页-最新（7天）工作信息统计-接口
export const workInfoForLast7Days = params => {
    // console.log('post提交', params)
    return request({
        url: '/api/blade-stat/home/workInfoForLast7Days',
        method: 'get',
        params
    })
}
//首页-全部的工作信息统计-接口
export const workInfoForAll = params => {
    // console.log('post提交', params)
    return request({
        url: '/api/blade-stat/home/workInfoForAll',
        method: 'get',
        params
    })
}

